var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "icon-path refresh",
    d: "M15.4557 11.6035C15.4557 11.9235 15.1965 12.1826 14.8765 12.1826H11.9826C11.6626 12.1826 11.4035 11.9235 11.4035 11.6035V8.70957C11.4035 8.38957 11.6626 8.13044 11.9826 8.13044C12.3026 8.13044 12.5617 8.38957 12.5617 8.70957V10.44C13.3096 9.44348 13.7183 8.23653 13.7183 6.97409C13.7183 3.78261 11.1235 1.18609 7.93061 1.18609C4.73913 1.18609 2.14435 3.78261 2.14435 6.97409C2.14435 10.1652 4.73913 12.7617 7.93061 12.7617C8.25044 12.7617 8.50957 13.0209 8.50957 13.3409C8.50957 13.6609 8.25044 13.9183 7.93061 13.9183C4.10087 13.9183 0.986088 10.8035 0.986088 6.97409C0.986088 3.14435 4.10087 0.027832 7.93061 0.027832C11.76 0.027832 14.8765 3.14435 14.8765 6.97409C14.8765 8.44348 14.4122 9.8487 13.5652 11.0244H14.8765C15.1965 11.0244 15.4557 11.2835 15.4557 11.6035Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.9fcba8731e9bf52ab7648e156a4ddd2d.svg";
export { ForwardRef as ReactComponent };